"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Heading = _interopRequireDefault(require("../../Typography/Heading/Heading"));

require("./Header.css");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Icon = _interopRequireDefault(require("../../Graphics/Icon/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @visibleName Table Header
 */
function Header(_ref) {
  var children = _ref.children,
      buttons = _ref.buttons,
      collapsible = _ref.collapsible,
      isOpen = _ref.isOpen,
      onToggleOpen = _ref.onToggleOpen;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: collapsible ? 'table-header-collapsible' : 'table-header'
  }, collapsible && /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    "aria-label": "expand row",
    size: "small",
    onClick: function onClick() {
      return onToggleOpen(!isOpen);
    }
  }, isOpen ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "minus"
  }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "plus"
  })), /*#__PURE__*/_react.default.createElement(_Heading.default, {
    level: "4"
  }, children), buttons && /*#__PURE__*/_react.default.createElement("span", {
    className: "table-header-buttons"
  }, buttons));
}

Header.propTypes = {
  /** Header label */
  children: _propTypes.default.node.isRequired,

  /** Is header collapsible */
  collapsible: _propTypes.default.bool,

  /** If header is opened or closed */
  isOpen: _propTypes.default.bool,

  /** On toggle function */
  onToggleOpen: _propTypes.default.func,

  /** Action buttons */
  buttons: _propTypes.default.node
};
Header.defaultProps = {
  collapsible: false,
  isOpen: false
};
var _default = Header;
exports.default = _default;